module.exports = __webpack_public_path__ + "media/react/pages/add_ons/assets/admissions/headshot_brittny-9090bdb31fff376958aa65f22b6819e5.jpg";